/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The file's purpose.
 */
export const FilePurpose = {
  BusinessVerification: "business_verification",
  RepresentativeVerification: "representative_verification",
  IndividualVerification: "individual_verification",
  MerchantUnderwriting: "merchant_underwriting",
  AccountRequirement: "account_requirement",
  IdentityVerification: "identity_verification",
} as const;
/**
 * The file's purpose.
 */
export type FilePurpose = ClosedEnum<typeof FilePurpose>;

/** @internal */
export const FilePurpose$inboundSchema: z.ZodNativeEnum<typeof FilePurpose> = z
  .nativeEnum(FilePurpose);
/** @internal */
export const FilePurpose$outboundSchema: z.ZodNativeEnum<typeof FilePurpose> =
  FilePurpose$inboundSchema;
